import { io, Socket } from 'socket.io-client'

import CreditSocket from '@/socket/credit/CreditSocket'

export default class SocketClient {
  socket: Socket

  Credit: CreditSocket

  constructor(serverUrl: string) {
    this.socket = io(serverUrl)
    this.Credit = new CreditSocket(this.socket)
  }

  connect(): void {
    console.log('connecting in index.ts')
    this.socket.connect()
  }

  disconnect(): void {
    this.socket.disconnect()
  }

  on(event: string, callback: (data: any) => void): void {
    this.socket.on(event, callback)
  }

  emit(event: string, data?: any) {
    this.socket.emit(event, data)
  }

  off(event: string, callback?: (data: any) => void): void {
    this.socket.off(event, callback)
  }
}
